import OWContainer from 'styles/styled-components/ow-container';
import { Spinner } from 'components/design';
import useController from '../controllers/edit-company-owner-controller';
import { CompanyOwnerForm } from '../components/company-owner-form';

export const EditCompanyOwnerRoute = () => {
    const { errors, isLoading, onCancel, onChange, onSubmit, formData, dataChanged, isEditCompanyOwnerLoading } =
        useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <CompanyOwnerForm
                    formData={formData}
                    errors={errors}
                    onCancel={onCancel}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    disableSubmit={!dataChanged}
                    isSaveLoading={isEditCompanyOwnerLoading}
                    isEdit={true}
                />
            )}
        </OWContainer>
    );
};
